import React from 'react';
import ImageDimensionsContext from '../../ImageDimensionsProvider';

const Image = props => {
  const { alt, 'aria-hidden': ariaHidden, height, src, width, ...otherProps } = props;

  return (
    <ImageDimensionsContext.Consumer>
      {imageDimensions => {
        const matchedImageDimensions = imageDimensions?.[src];
        return (
          <img
            alt={alt || ''}
            height={height || matchedImageDimensions?.height}
            width={width || matchedImageDimensions?.width}
            src={src}
            {...otherProps}
          />
        );
      }}
    </ImageDimensionsContext.Consumer>
  );
};

export default Image;
